'use client';

import { useLocale } from 'next-intl';
import { SVGProps } from 'react';
import OrdermageLogoCZSVG from '@/assets/images/ordermage-logo-cz.svg';
import OrdermageLogoWorldSVG from '@/assets/images/ordermage-logo-world.svg';
import { TranslationLanguage } from '@/shared/i18n/constants';

type Props = SVGProps<HTMLElement>;
export const OrderMageLogo = (props: Props) => {
    const locale = useLocale();
    const Logo = locale === TranslationLanguage.CS ? OrdermageLogoCZSVG : OrdermageLogoWorldSVG;

    return <Logo {...props} />;
};
